import SocialAccountSection from "../../pages/custom-components/SocialPublish/SocialAccounts/SocialAccountSection";
import TargetStorageSection from "../../pages/custom-components/SocialPublish/TargetStorageAccounts/TargetStorageSection";

export default function SocialAccountPage(){
    return (
        <>
            <SocialAccountSection/>
            <TargetStorageSection/>
        </>
    )
}